<div class="visual-selection-title">
  <div class="prompt-area" >
    <div class="prompt">
      <img src="{{ isDarkMode ? './assets/images/icon-visual-selection-darkMode.svg' : './assets/images/icon-visual-selection-lightMode.svg' }}" />
      <div class="prompt-text">{{ 'remoteControl_MultiScreen_InactivePrompt' | xsI18n }}</div>
    </div>
    <div class="prompt-buttons">
      <button class="xs-btn btn-outline btn-space" (click)="close()"> {{ 'xs_cancel_label' | xsI18n  }} </button>
      <button class="xs-btn btn-primary" (click)="backToVirtual()"> {{ 'remoteControl_MultiScreen_SelectAll' | xsI18n  }} </button>
    </div>
  </div>
  <div class="close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top" (click)="close()"></div>
</div>
<div clss="visual-selection-mask-area">
  <!--
    This mask area cannot cover all buttons once work-panel-bar-container is overflowed,
    another mask element can be found in rc-view-v2 component by class name "rc-multi-view-mask-area"
  -->
  <div id="multi-display-visual-selection" class="mask-area">
  </div>
  <div class="rectangle" *ngFor="let rect of rectangles"
    [ngStyle]="{
      'top': rect.top + 'px',
      'left': rect.left + 'px',
      'width': rect.width + 'px',
      'height': rect.height + 'px'
    }"
    (click)="click(rect)">
    <div class="rectangle-name">
      {{ rect.name }}
    </div>
  </div>
</div>
